import React, { useState, useEffect } from "react";
import axios from "axios";
import Breadcrumb from "../../components/breadcrumb/index";
import DataTable_Component from "../../components/vendors/Data Table/index";
import Status_modal from "../../components/manageInvoice/status_modal/index";
import Add_data_modal from "../../components/vendors/update_data_modal/index";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEye,
  faPenToSquare,
  faTrash,
  faEnvelope,
  faCopy,
} from "@fortawesome/free-solid-svg-icons";
import Layouts from "../../layouts/layouts";
import VendorDetailModal from "../../components/vendors/Vendor Details";
import * as XLSX from "xlsx"; // Import XLSX library for Excel export

export default function Vendor() {
  const title = "Vendor Details";
  const [apistate, setApiState] = useState([]);
  const [apicol, setApiCol] = useState([]);
  const [selectVal, setSelectval] = useState([]);
  const [openModal, setOpenModal] = useState(true);
  const [selectVal_details, setSelectVal_details] = useState([]);
  const [details_modal_show, set_details_modal_Show] = useState(false);
  const [vendorCount, setVendorCount] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [search, setSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState("");

  const [open_add_modal, setOpen_add_modal] = useState({
    render: true,
    modal_open: false,
  });

  const [open_update_modal, setOpen_update_modal] = useState({
    render: true,
    modal_open: false,
  });
  const [update_modal_data, setUpdate_modal_data] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [showVendorDetailModal, setShowVendorDetailModal] = useState(false);
  const [selectedVendor, setSelectedVendor] = useState(null);
  const userRole = localStorage.getItem("userRole");

  const brad = [
    {
      name: "home",
    },
    {
      name: title,
    },
  ];

  const formatDate = (dateString) => {
    const options = { year: "numeric", month: "2-digit", day: "2-digit" };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  const columns = [
    {
      name: <b>Vendor Name</b>,
      selector: (row) => (row.id_user ? row.id_user.name : "N/A"),
      sortable: true,
    },
    {
      name: <b>OnBoard Date</b>,
      selector: (row) => formatDate(row.onBoardingDate) || "-",
      sortable: true,
    },
    {
      name: <b>City</b>,
      selector: (row) => row.city,
      sortable: true,
    },
    {
      name: <b>Created At</b>,
      selector: (row) => formatDate(row.createdAt),
      sortable: true,
    },
    {
      name: <b>Status</b>,
      cell: (row) => {
        const status = row.status ? row.status.toLowerCase() : "";
        return (
          <button
            className={`btn p-0 px-1 ${
              status === "active"
                ? "btn-success"
                : status === "inactive"
                  ? "btn-danger"
                  : ""
            }`}
          >
            {row.status || "Unknown"}
          </button>
        );
      },
    },
    {
      name: <b>Modified At</b>,
      selector: (row) =>
        row.updatedAt && new Date(row.updatedAt).toLocaleDateString(),
      sortable: true,
    },
    {
      name: <b>Action</b>,
      cell: (row) => (
        <>
          {/* Update & Delete buttons (Only for Superadmin) */}
          {userRole === "superadmin" && (
            <>
              <button
                onClick={() => setUpdateStoreBtn(row)}
                className="btn btn-info btn-sm ms-1"
              >
                <FontAwesomeIcon icon={faPenToSquare} />
              </button>
              {/* <button
                onClick={() => delete_row(row)}
                className="btn btn-danger btn-sm ms-1"
              >
                <FontAwesomeIcon icon={faTrash} />
              </button> */}
            </>
          )}

          {/* View button (Accessible to both Superadmin & Admin) */}
          <button
            onClick={() => viewVendor(row)}
            className="btn btn-primary btn-sm ms-1"
          >
            <FontAwesomeIcon icon={faEye} />
          </button>
        </>
      ),
    },
  ];

  const handleShow = (row) => {
    setOpenModal(!openModal);
    setSelectval(row);
  };

  const updateVendor = (updatedVendor) => {
    setApiState((prev) =>
      prev.map((vendor) =>
        vendor._id === updatedVendor._id ? updatedVendor : vendor,
      ),
    );
  };

  const fetchData = async (page = 1, perPage = rowsPerPage) => {
    try {
      const token = localStorage.getItem("token");
      const userRole = localStorage.getItem("userRole");

      let apiUrl;

      if (userRole === "superadmin") {
        apiUrl = `${process.env.REACT_APP_BASE_URL}/api/v1/vendors`;
      } else if (userRole === "admin") {
        apiUrl = `${process.env.REACT_APP_BASE_URL}/api/v1/hub/admin/vendors`;
      } else if (userRole === "clientmanager") {
        apiUrl = `${process.env.REACT_APP_BASE_URL}/api/v1/hub/client/vendors`;
      }

      let query = `?page=${page}&limit=${perPage}`;

      if (search) query += `&search=${search}`;
      if (statusFilter) query += `&status=${statusFilter}`;

      const response = await axios.get(`${apiUrl}${query}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      if (Array.isArray(response.data.vendors)) {
        setApiState(response.data.vendors);
        setTotalRecords(response.data.count || 0);
      }

      setApiCol(columns);
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };

  useEffect(() => {
    fetchData(currentPage, rowsPerPage);
  }, [currentPage, rowsPerPage, search, statusFilter]);

  const setStoreBtn = () => {
    setOpen_add_modal({ render: !open_add_modal.render, modal_open: true });
  };

  const setUpdateStoreBtn = (row) => {
    setOpen_update_modal({
      render: !open_update_modal.render,
      modal_open: true,
    });
    setUpdate_modal_data(row);
  };

  const copyLink = () => {
    alert(46);
  };

  // const delete_row = (row) => {
  //   Swal.fire({
  //     icon: "warning",
  //     title: "You won't be able to revert this!",
  //     showCancelButton: true,
  //     confirmButtonText: "Yes",
  //   }).then((result) => {
  //     if (result.isConfirmed) {
  //       const token = localStorage.getItem("token");
  //       if (!token) {
  //         console.error("No token found");
  //         return;
  //       }
  //       axios
  //         .delete(
  //           `${process.env.REACT_APP_BASE_URL}/api/v1/vendor/${row._id}`,
  //           {
  //             headers: {
  //               "Content-Type": "application/json",
  //               Authorization: `Bearer ${token}`,
  //             },
  //           },
  //         )

  //         .then(() => {
  //           Swal.fire("Deleted!", "Vendor has been deleted.", "success");
  //           fetchData(currentPage);
  //         })
  //         .catch((error) => {
  //           Swal.fire("Error!", "Vendor could not be deleted.", "error");
  //         });
  //     }
  //   });
  // };

  const viewVendor = (vendor) => {
    setSelectedVendor(vendor);
    setShowVendorDetailModal(true);
  };

  const exportToExcel = async () => {
    try {
      const token = localStorage.getItem("token");
      const userRole = localStorage.getItem("userRole");

      let apiUrl;

      if (userRole === "superadmin") {
        apiUrl = `/api/v1/vendors`;
      } else if (userRole === "admin") {
        apiUrl = `/api/v1/hub/admin/vendors`;
      } else if (userRole === "clientmanager") {
        apiUrl = `/api/v1/hub/client/vendors`;
      } else {
        return;
      }

      // ❗ NO pagination params (IMPORTANT)
      let query = `?`;

      if (search) query += `search=${search}&`;
      if (statusFilter) query += `status=${statusFilter}&`;

      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}${apiUrl}${query}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const allVendors = response.data.vendors || [];

      const transformedData = allVendors.map((vendor) => ({
        "Vendor Name": vendor.id_user?.name || "N/A",
        "Phone Number": vendor.id_user?.phonenumber || "N/A",
        "Home Number": vendor.homenumber || "-",
        "Temporary Address": vendor.tempaddress || "-",
        City: vendor.city || "-",
        State: vendor.state || "-",
        "Permanent Address": vendor.permanentaddress || "-",
        Coordinates: vendor.coordinates
          ? `${vendor.coordinates.latitude}, ${vendor.coordinates.longitude}`
          : "-",
        Description: vendor.description || "-",
        "User Email": vendor.id_user?.email || "N/A",
        "Created At": formatDate(vendor.createdAt),
        "Modified At": vendor.updatedAt ? formatDate(vendor.updatedAt) : "N/A",
        Status: vendor.status || "Unknown",
      }));

      const worksheet = XLSX.utils.json_to_sheet(transformedData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Vendors");

      XLSX.writeFile(workbook, "VendorsData.xlsx");
    } catch (error) {
      console.error("Export error:", error);
    }
  };

  return (
    <>
      <Layouts />
      <Status_modal row={selectVal} openModal={openModal} />
      <Add_data_modal
        select_data={update_modal_data}
        open_update_data_modal={open_update_modal}
        onUpdateVendor={updateVendor}
      />
      <VendorDetailModal
        show={showVendorDetailModal}
        onHide={() => setShowVendorDetailModal(false)}
        vendor={selectedVendor}
      />
      <div className="container-fluid">
        {/* <Breadcrumb title={title} brad={brad} /> */}
        <div className="row my-3">
          <div className="col-12">
            <div className="card" style={{ borderTop: "2px solid #4723d9" }}>
              <div className="card-header d-flex justify-content-between border-bottom pb-1">
                <h4>{title}</h4>
                <div>
                  {/* <Link to="/create-vendor">
                    <div className="btn btn-info btn-sm text-white me-2">
                      Add Vendor
                    </div>
                  </Link> */}
                  {userRole === "superadmin" && (
                    <Link to="/create-vendor">
                      <div className="btn btn-info btn-sm text-white me-2">
                        Add Vendor
                      </div>
                    </Link>
                  )}
                  <button
                    onClick={exportToExcel}
                    className="btn btn-success btn-sm text-white"
                  >
                    Export to Excel
                  </button>
                </div>
              </div>
              <div className="card-body">
                <DataTable_Component
                  apidata={apistate}
                  columns={apicol}
                  totalRecords={totalRecords}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  rowsPerPage={rowsPerPage}
                  setRowsPerPage={setRowsPerPage}
                  search={search}
                  setSearch={setSearch}
                  statusFilter={statusFilter}
                  setStatusFilter={setStatusFilter}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
